import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { EduSchool } from '@common/types/edu-course.type';

import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class EduSchoolsHttpService extends BaseHttpService {
    public getEduSchools(): Observable<EduSchool[]> {
        return this.http.get<HttpDataResponse<EduSchool[]>>(this.formatEduServiceApiUrl('schools')).pipe(
            shareReplay(),
            map((response) => response.data)
        );
    }
}
